export default "__VITE_ASSET__EZhYxJ4Z__"